/*
 * The MIT License
 *
 * Copyright (c) 2019- Nordic Institute for Interoperability Solutions (NIIS)
 * Copyright (c) 2018 Estonian Information System Authority (RIA),
 * Nordic Institute for Interoperability Solutions (NIIS), Population Register Centre (VRK)
 * Copyright (c) 2015-2017 Estonian Information System Authority (RIA), Population Register Centre (VRK)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
import type { App } from 'vue';

// Format date string. Result YYYY-MM-DD.
export function formatDate(value: string): string {
  const timestamp = Date.parse(value);

  if (isNaN(timestamp)) {
    return '-';
  }

  const date = new Date(value);

  return (
    date.getFullYear() +
    '-' +
    (date.getMonth() + 1).toString().padStart(2, '0') +
    '-' +
    date.getDate().toString().padStart(2, '0')
  );
}

// Format date string. Result YYYY-MM-DD HH:MM.
export function formatDateTime(value: string): string {
  const timestamp = Date.parse(value);

  if (isNaN(timestamp)) {
    return '-';
  }

  const date = new Date(value);

  return (
    date.getFullYear() +
    '-' +
    (date.getMonth() + 1).toString().padStart(2, '0') +
    '-' +
    date.getDate().toString().padStart(2, '0') +
    ' ' +
    date.getHours().toString().padStart(2, '0') +
    ':' +
    date.getMinutes().toString().padStart(2, '0')
  );
}

// Format date string. Result YYYY-MM-DD HH:MM:SS.
export function formatDateTimeSeconds(value: string): string {
  const timestamp = Date.parse(value);

  if (isNaN(timestamp)) {
    return '-';
  }

  const date = new Date(value);

  return (
    formatDateTime(value) + ':' + date.getSeconds().toString().padStart(2, '0')
  );
}

export function createFilters(i18nMessages = {}) {
  return {
    install(app: App) {
      app.config.globalProperties.$filters = {
        formatDate,
        formatDateTime,
        formatDateTimeSeconds,
      };
    },
  };
}
